const faqs = [
  {
    question: "What is Shumba Money?",
    answer: "Shumba Money is a Zimbabwean start-up that specializes in clothing, marketing and advertising, entertainment, entertainment news, Beitbridge events, events planning, fashion consultation, and sending and receiving money within Zimbabwe. We are committed to providing our customers with the best possible service, and we are always looking for new ways to improve our offerings.",
  },
  {
    question: "What is the meaning of the name 'Shumba Money'?",
    answer: "Shumba is a Shona word that means 'lion.' The name Shumba Money reflects the company's strength and power, as well as its commitment to providing its customers with the best possible service.",
  },
  {
    question: "What services does Shumba Money offer?",
    answer: "Shumba Money offers a range of services including clothing, marketing and advertising, entertainment, entertainment news, Beitbridge events, events planning, fashion consultation, and sending and receiving money within Zimbabwe. Feel free to visit our services page or even call us or visit our physical location to find more.",
  },
  {
    question: "How can I send and receive money using Shumba Money?",
    answer: "You can send and receive money in person at one of our agent locations. Get in touch with us to know our agent locations.",
  },
  {
    question: "Can I use Shumba Money for international money transfers?",
    answer: "Currently, Shumba Money focuses on providing money transfer services within Zimbabwe. We do not support international money transfers at the moment. However, we are constantly working to expand our services, so stay tuned for updates!",
  },
  {
    question: "What types of clothing does Shumba Money offer?",
    answer: "Shumba Money offers a wide range of clothing options, including trendy and fashionable apparel for both men and women. Whether you're looking for casual wear, formal attire, or accessories, we've got you covered!",
  },
  {
    question: "Can Shumba Money help with event planning?",
    answer: "Absolutely! Shumba Money has a dedicated events planning team that can assist you in organizing and managing various types of events. Whether it's a corporate gathering, a wedding, or a social event, we can help you make it a memorable and successful occasion.",
  },
  {
    question: 'Where can I find entertainment news and updates from Shumba Money?',
    answer: 'Stay up-to-date with the latest entertainment news and updates from Shumba Money by following us on social media. We regularly share exciting news, event highlights, and exclusive content to keep you entertained and informed.',
  },
  {
    question: 'Does Shumba Money provide fashion consultation services?',
    answer: 'Yes, Shumba Money offers fashion consultation services to help you enhance your personal style or revamp your wardrobe. Our fashion experts can provide valuable advice on fashion trends, outfit coordination, and finding the perfect look for any occasion.',
  },
  {
    question: 'What are some of the clothing brands that Shumba Money sells?',
    answer: 'We sell a variety of clothing brands, including local Zimbabwean brands and international brands. We are always looking for new brands to add to our selection, and we are committed to providing our customers with the latest fashion trends.'
  },
];

export default faqs;